import {DatePipe} from "@angular/common";
import {Component, inject} from '@angular/core';
import {ReactiveFormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'euroports-error-dialog',
    imports: [
        MatDialogContent,
        MatDialogActions,
        TranslateModule,
        MatDialogClose,
        MatButton,
        ReactiveFormsModule,
        MatDialogTitle,
        DatePipe,
    ],
    templateUrl: './error-dialog.component.html'
})
export class ErrorDialogComponent {
  data = inject<{
    message: string;
}>(MAT_DIALOG_DATA);

  date : Date = new Date();

}
